import { Configuration as DmsConfiguration, DmsApi } from '@conacyt/dms-client';
const dmsConfiguration = new DmsConfiguration({ basePath: '/services/dmsms/api' });

const dmsApi = new DmsApi(dmsConfiguration);
export { dmsApi };
